document.addEventListener("DOMContentLoaded", function () {
  const scope = document.querySelector(".lpWrap");
  if (!scope) {
    console.warn("[LP] .lpWrap not found");
    return;
  }
  /* =========================
     0) Swiper存在チェック
     ========================= */
  if (!window.Swiper) {
    console.warn("[LP] Swiper not loaded");
    // Swiper無くても他は動かしたいので return しない
  }

  /* =========================
     1) Swiper初期化ヘルパー（安全版）
     - el は Element を渡す
     - pagination / navigation は存在する時だけ付ける
     ========================= */
  function initSwiper(rootEl, options) {
    if (!window.Swiper) return;
    if (!rootEl) return;

    try {
      if (rootEl.swiper) rootEl.swiper.destroy(true, true); // 二重初期化防止
      new Swiper(rootEl, options);
    } catch (e) {
      console.error("[LP] Swiper init failed:", rootEl, e);
    }
  }

  /* =========================
     2) REASON01（.reason01 内の swiper）
     ========================= */
  (function () {
    const root = scope.querySelector(".reason01 .swiper");
    if (!root) return;

    const paginationEl = root.querySelector(".swiper-pagination");
    const nextEl = root.querySelector(".swiper-button-next");
    const prevEl = root.querySelector(".swiper-button-prev");

    const opts = {
      loop: true,
      observer: true,
      observeParents: true,
    };

    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }
    if (nextEl && prevEl) {
      opts.navigation = { nextEl, prevEl };
    }

    initSwiper(root, opts);
  })();

  /* =========================
     3) 自動再生（.swiperauto）
     - 複数ある可能性あるので All
     ========================= */
  (function () {
    const roots = scope.querySelectorAll(".swiperauto");
    if (!roots.length) return;

    roots.forEach((root) => {
      initSwiper(root, {
        loop: true,
        autoplay: { delay: 8000, disableOnInteraction: false },
        observer: true,
        observeParents: true,
      });
    });
  })();

  /* =========================
     4) kensho（researchSec）
     ========================= */
  (function () {
    const root = scope.querySelector(".researchSec .kenshoSwiper");
    if (!root) return;

    const paginationEl = root.querySelector(".swiper-pagination");

    const opts = {
      loop: false,
      centeredSlides: false,
      slidesPerView: 1.05,
      spaceBetween: 12,
      breakpoints: {
        768: { slidesPerView: 1.6, spaceBetween: 16 },
        1024: { slidesPerView: 2.0, spaceBetween: 24 },
      },
      observer: true,
      observeParents: true,
    };

    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }

    initSwiper(root, opts);
  })();

  /* =========================
     5) voice（.voiceSwiper）
     ========================= */
  (function () {
    const root = scope.querySelector(".voiceSwiper");
    if (!root) return;

    const paginationEl = root.querySelector(".swiper-pagination");

    const opts = {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
    };

    if (paginationEl) {
      opts.pagination = { el: paginationEl, clickable: true };
    }

    initSwiper(root, opts);
  })();

  /* =========================
     6) jQuery系（あれば）
     - ここも .lpWrap 内に限定
     ========================= */
  if (window.jQuery) {
    jQuery(function ($) {
      // FAQ
      $(scope)
        .find("#qa_area dl dt")
        .on("click", function () {
          $(this).next().slideToggle();
          $(this).toggleClass("on");
        });

      // これがLP内に無いなら何もしない
      $(scope)
        .find("#close")
        .on("click", function () {
          $(scope).find("#menu").toggleClass("on");
        });

      // 旧アコーディオン（存在すれば）
      $(scope)
        .find(".accordion_q")
        .on("click", function () {
          $(this).next().slideToggle(200);
          $(this).toggleClass("arrow");
        });

      // 固定ボタン（LP内だけ）
      $(window).on("scroll", function () {
        const y = $(this).scrollTop();
        if (y > 3000) $(scope).find(".fixBtn").fadeIn(600);
        else $(scope).find(".fixBtn").fadeOut(600);
      });
    });
  }

  /* =========================
     7) アコーディオン（画像切替）
     - これも LP内だけに限定
     ========================= */
  (function () {
    scope.querySelectorAll(".accordion-header").forEach((header) => {
      header.addEventListener("click", () => {
        const content = header.nextElementSibling;
        if (!content) return;

        const icon = header.querySelector(".accordion-toggle");
        const isOpen = content.style.display === "block";
        content.style.display = isOpen ? "none" : "block";

        if (icon && icon.tagName === "IMG") {
          icon.src = isOpen
            ? "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/seedetails_btn_under.png"
            : "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/seedetails_btn_top.png";
          icon.classList.toggle("open", !isOpen);
        }
      });
    });

    scope.querySelectorAll(".accordion-header2").forEach((header) => {
      header.addEventListener("click", () => {
        const content = header.nextElementSibling;
        if (!content) return;

        const icon = header.querySelector(".accordion-toggle");
        const isOpen = content.style.display === "block";
        content.style.display = isOpen ? "none" : "block";

        if (icon && icon.tagName === "IMG") {
          icon.src = isOpen
            ? "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/precautions_btn_under.png"
            : "https://cdn.shopify.com/s/files/1/0508/5347/8562/files/precautions_btn_top.png";
          icon.classList.toggle("open", !isOpen);
        }
      });
    });
  })();

  /* =========================
     8) #TeamMueller modal（LP内だけ）
     ========================= */
  (function () {
    const modal = scope.querySelector("#teamModal");
    const openBtn = scope.querySelector("#openTeamMueller");
    if (!modal || !openBtn) return;

    function openModal() {
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("tmOpen");
    }
    function closeModal() {
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("tmOpen");
    }

    openBtn.addEventListener("click", openModal);

    modal.addEventListener("click", (e) => {
      if (e.target && e.target.hasAttribute("data-close")) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") {
        closeModal();
      }
    });
  })();
});
